import { Link } from 'react-router-dom'
import { CATEGORIES } from '../data/calculators'
import { SITE } from '../lib/site'
import { useLocale, localizedHref } from '../i18n/locale'
import { t } from '../i18n/strings'
import { categoryName } from '../i18n/calculators'

const GUIDES = [
  { slug: 'how-to-paint-a-room', name: 'How to Paint a Room', nameFr: 'Peindre une pièce' },
  { slug: 'bathroom-renovation-checklist', name: 'Bathroom Checklist', nameFr: 'Liste salle de bain' },
  { slug: 'kitchen-remodel-planning-guide', name: 'Kitchen Remodel Guide', nameFr: 'Guide cuisine' },
]

export default function Footer() {
  const locale = useLocale()
  const L = (en: string) => localizedHref(en, locale)
  const tr = (k: string) => t(locale, k)

  return (
    <footer className="mt-16 border-t border-border bg-surface-2">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-4 py-10 md:grid-cols-4">
        <div>
          <h3 className="text-sm font-semibold text-text">{tr('footer.calculators')}</h3>
          <ul className="mt-2 space-y-1 text-sm text-text-muted">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to={L(`/calculators/${c.slug}/`)} className="hover:text-brand-text">{categoryName(c.slug, c.name, locale)}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-text">{tr('footer.guides')}</h3>
          <ul className="mt-2 space-y-1 text-sm text-text-muted">
            {GUIDES.map((g) => (
              <li key={g.slug}>
                <Link to={`/guides/${g.slug}/`} className="hover:text-brand-text">{locale === 'fr' ? g.nameFr : g.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-text">{tr('footer.company')}</h3>
          <ul className="mt-2 space-y-1 text-sm text-text-muted">
            <li><Link to={L('/about/')} className="hover:text-brand-text">{tr('nav.about')}</Link></li>
            <li><Link to={L('/kanban-board/')} className="hover:text-brand-text">{tr('footer.freeKanban')}</Link></li>
            <li><Link to={L('/contact/')} className="hover:text-brand-text">{tr('footer.contact')}</Link></li>
            <li><Link to={L('/how-we-calculate/')} className="hover:text-brand-text">{tr('footer.howWeCalculate')}</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-sm font-semibold text-text">{tr('footer.legal')}</h3>
          <ul className="mt-2 space-y-1 text-sm text-text-muted">
            <li><Link to={L('/terms/')} className="hover:text-brand-text">{tr('footer.terms')}</Link></li>
            <li><Link to={L('/privacy/')} className="hover:text-brand-text">{tr('footer.privacy')}</Link></li>
            <li><Link to={L('/affiliate-disclosure/')} className="hover:text-brand-text">{tr('footer.affiliate')}</Link></li>
            <li><button type="button" onClick={() => window.dispatchEvent(new Event('rs-open-consent'))} className="hover:text-brand-text">{tr('consent.manage')}</button></li>
          </ul>
        </div>
      </div>
      {/* "Featured on" strip — third-party directory placements that link back
          to renosheets.com. Adds backlink authority for SEO and a tiny trust
          signal for visitors. Image has fixed dimensions so it doesn't shift
          the footer layout while loading. */}
      <div className="border-t border-border px-4 py-4">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-3 text-xs text-text-muted sm:justify-start">
          <span className="font-medium text-text-muted">{tr('footer.featuredOn')}</span>
          <a
            href="https://findly.tools/reno-sheets?utm_source=reno-sheets"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Featured on Findly.tools"
            className="inline-flex"
          >
            <img
              src="https://findly.tools/badges/findly-tools-badge-light.svg"
              alt="Featured on Findly.tools"
              width={175}
              height={55}
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
      </div>

      <div className="border-t border-border px-4 py-5 text-center text-xs text-text-muted">
        <p className="mx-auto max-w-3xl">{tr('footer.disclaimer')}</p>
        <p className="mt-1">{tr('footer.commission')} © {new Date().getFullYear()} RenoSheets — {SITE.tagline}</p>
      </div>
    </footer>
  )
}
